import { config } from "api/apiRoutes";
import { torAxios } from "api/serviceConfig";
import CustomerIdRequest from "api/sharedModels/CustomerIdRequest";
import { PageRequest } from "api/sharedModels/PageRequest";
import { AddCustomerGroupRequest } from "api/usersRequestModels/AddCustomerGroupRequest";
import { AddCustomerRequest } from "api/usersRequestModels/AddCustomerRequest";
import { AddGlobalGroupRequest } from "api/usersRequestModels/AddGlobalGroupRequest";
import { AddUserRequest } from "api/usersRequestModels/AddUserRequest";
import { Page } from "models/shared/Page";
import { Customer } from "models/users/Customer";
import { MarvelModule } from "models/users/MarvelModule";
import { MarvelUser } from "models/users/MarvelUser";
import { UserGroup } from "models/users/UserGroup";
import { UserInfo } from "models/users/UserInfo";

export class UserManagementService {
    async getUsersList(data: PageRequest) {
        return await torAxios.get<Page<MarvelUser>>(config.users, {
            params: data,
        });
    }

    async addUser(data: AddUserRequest) {
        return await torAxios.post(config.users, data);
    }

    async addCustomer(data: AddCustomerRequest) {
        return await torAxios.post(config.customers, data);
    }

    async getCustomersList(data: PageRequest) {
        return await torAxios.get<Page<Customer>>(config.customers, {
            params: data,
        });
    }

    async getModulesList(data: CustomerIdRequest) {
        return await torAxios.get<MarvelModule[]>(config.modules, {
            params: data,
        });
    }

    async getValidUsers(data: CustomerIdRequest) {
        return await torAxios.get<Page<MarvelUser>>(config.tempUsers, {
            params: {
                customerId: data.customerId,
            },
        });
    }

    async getUserInfo() {
        return await torAxios.get<UserInfo>(config.userInfo);
    }

    async getCustomer(id: number) {
        return await torAxios.get<Customer>(config.getCustomer(id));
    }

    async getAllCustomers() {
        return await torAxios.get<Customer[]>(config.allCustomers);
    }

    async getCustomerGroups(data: PageRequest) {
        return await torAxios.get<Page<UserGroup>>(config.customerGroups(data.customerId), {
            params: {
                pageSize: data.pageSize,
                pageNumber: data.pageNumber,
            },
        });
    }

    async getGlobalGroups(pageSize: number, pageNumber: number) {
        return await torAxios.get<Page<UserGroup>>(config.globalGroups, {
            params: {
                pageSize: pageSize,
                pageNumber: pageNumber,
            },
        });
    }

    async addGlobalGroup(data: AddGlobalGroupRequest) {
        return await torAxios.post(config.addGlobalGroup, data);
    }

    async addCustomerGroup(data: AddCustomerGroupRequest) {
        return await torAxios.post(config.addCustomerGroup, data);
    }

    async getGlobalUsers() {
        return await torAxios.get<MarvelUser[]>(config.globalUsers);
    }

    async getCustomerUsers(customerId: number) {
        return await torAxios.get<MarvelUser[]>(config.customerUsers(customerId));
    }
}
